<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Refund Orders</h1>
            <hr>
            <mdb-row>
                <mdb-col md="2">
                    <mdb-input v-on:keyup.enter="getData()" label="#Order Number" v-model="order_number" />
                </mdb-col>
                <mdb-col md="2" class="d-flex align-items-center">
                    <select v-model="status" class="browser-default custom-select">
                        <option value="">All</option>
                        <option value="0">Pending</option>
                        <option value="1">Refunded</option>
                        <option value="2">Compensated</option>
                        <option value="3">Rejected</option>
                    </select>
                </mdb-col>
                <mdb-col md="2">
                    <mdb-date-picker :autoHide="true" v-model="from" label="Date From" />
                </mdb-col>
                <mdb-col md="2">
                    <mdb-date-picker :autoHide="true" v-model="to" label="Date To" />
                </mdb-col>
                <mdb-col md="4" class="align-self-center">
                    <mdb-btn @click="getData()" outline="primary" size="sm">Search</mdb-btn>
                </mdb-col>
            </mdb-row>
            <p class="text-danger" v-if="loading">Please Wait... Fetching Data dont panic don't spam refresh!</p>
            <mdb-tbl responsive striped>
                <mdb-tbl-head>
                <tr>
                    <th width="5%">#</th>
                    <th>Order Information</th>
                    <th>Target User</th>
                    <th class="text-right">Refund Amt</th>
                    <th class="text-right">Date Time</th>
                    <th class="text-right">Action</th>
                </tr>
                </mdb-tbl-head>
                    <mdb-tbl-body>
                    <tr v-for="(order, index) in refund" :key="order.id" style="cursor: pointer" @click="showOrderDetail(order.service_order.id)">
                        <td>{{index+1}}</td>
                        <td class="text-center">
                            <div v-if="order.service_order.status=='CANCELLED'" class="status-cancelled">{{order.service_order.status}}</div>
                            <div v-if="order.service_order.status=='NEW'" class="status-new">{{order.service_order.status}}</div>
                            <div v-if="order.service_order.status=='COMPLETED'" class="status-completed">{{order.service_order.status}}</div>
                            <div class="font-weight-bold">{{order.service_order.order_number}}</div>
                            <div class="text-warning" v-if="order.is_refunded==0 && order.is_deleted==0">Pending Refund</div>
                            <div class="text-danger" v-if="order.is_deleted==1">Refund Rejected</div>
                            <div class="text-success" v-if="order.is_refunded==1 && !order.promo_code_config_id">Refunded</div>
                            <div class="text-success" v-if="order.is_refunded==1 && order.promo_code_config_id">Compensated Promo Code</div>
                            <div>{{order.reason}}</div>
                            <div style="font-size: 0.8rem;" class="text-danger">
                                {{order.remarks}}
                            </div>
                            <div>{{momentFormat16(order.service_order.created_at)}}</div>
                        </td>
                        <td>
                            <div class="order-number-text font-weight-bold" @click="navigateToUser(order.service_order.customer_user.phone_number)">{{order.service_order.customer_user.name}}</div>
                            <div class="mb-1">{{order.service_order.customer_user.phone_number}}</div>
                        </td>
                        <td class="text-right">
                            <div class="d-flex flex-row justify-content-end">
                                <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='EWALLET_TNG'" trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">EGHL TnG</span>
                                    <a slot="reference">
                                    <img :src="require('@/assets/tng.png')" style="height: 20px; width: 20px" />
                                    </a>
                                </mdb-tooltip>
                                <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='ONLINE_BANKING'" trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">Online Banking</span>
                                    <a slot="reference">
                                    <img :src="require('@/assets/online_banking.png')" style="height: 20px; width: 20px" />
                                    </a>
                                </mdb-tooltip>
                                <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='CREDIT_DEBIT_CARD'" trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">Card</span>
                                    <a slot="reference">
                                        <img :src="require('@/assets/card.png')" style="height: 20px; width: 20px" />
                                    </a>
                                </mdb-tooltip>
                                <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='EWALLET'" trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">E-Wallet</span>
                                    <a slot="reference">
                                        <img :src="require('@/assets/e_wallet.png')" style="height: 20px; width: 20px" />
                                    </a>
                                </mdb-tooltip>
                                <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='TNG'" trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">Touch and Go eWallet</span>
                                    <a slot="reference">
                                        <img :src="require('@/assets/tng.png')" style="height: 20px; width: 20px" />
                                    </a>
                                </mdb-tooltip>
                                <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='CASH'" trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">Cash</span>
                                    <a slot="reference">
                                        <img :src="require('@/assets/cash.png')" style="height: 20px; width: 20px" />
                                    </a>
                                </mdb-tooltip>
                                <div class="ml-2" style="text-decoration: line-through;" v-if="order.final_refund_amount">RM {{order.refund_amount}}</div>
                                <div class="ml-2" v-if="!order.final_refund_amount">RM {{order.refund_amount}}</div>
                            </div>
                            <div v-if="order.final_refund_amount" class="font-weight-bold"><mdb-icon icon="percentage" /> RM {{order.final_refund_amount}}</div>
                        </td>
                        <td class="text-right">
                            <div>{{momentFormat16(order.created_at)}}</div>
                            <div class="text-success">{{momentFormat(order.refunded_at)}}</div>
                        </td>
                        <td class="text-right d-flex flex-column" @click.prevent.stop>
                            <mdb-spinner small v-if="order.is_loading"/>
                            <mdb-tooltip v-if="order.admin!=null" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Action By</span>
                                <a slot="reference">
                                    {{order.admin.name}}
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="order.promo_code_config!=null" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Promo Code</span>
                                <a slot="reference">
                                    {{order.promo_code_config.code}}
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="!order.is_loading && order.is_refunded==0 && order.is_deleted==0" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Refund Cash</span>
                                <a slot="reference">
                                    <mdb-btn  @click="showSubmitRefund(order)" color="success" size="sm"><mdb-icon far icon="money-bill-alt" class="mr-2" />Refund Cash</mdb-btn>
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="!order.is_loading && order.is_refunded==0 && order.is_deleted==0 && order.reason!='DISPUTE_REFUND'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Compensate Voucher</span>
                                <a slot="reference">
                                    <mdb-btn @click="showCompensateVoucher(order)" color="primary" size="sm"><mdb-icon icon="percentage" class="mr-2" />Compensate Voucher</mdb-btn>
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="!order.is_loading && order.is_refunded==0 && order.is_deleted==0" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Refund Decline</span>
                                <a slot="reference">
                                    <mdb-btn @click="rejectRefund(order)" color="danger" size="sm"><mdb-icon icon="times" class="mr-2" />Reject</mdb-btn>
                                </a>
                            </mdb-tooltip>
                        </td>
                    </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <ConfirmationModal :visible="confirmation_voucher" :close="closeOrderDetailComponent" title="Confirm Compensate Voucher?" :submit="compensateVoucher" />
            <ConfirmationModal :visible="confirmation_refund" :close="closeOrderDetailComponent" title="Confirm Refunded?" :submit="submitRefund" />
            <OrderDetailComponent :promo_codes="promo_codes" :id="focus_order_id" :visible="order_detail_component" :close="closeOrderDetailComponent" :callback="callback" />
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbRow, mdbCol, mdbTbl, mdbTblHead, mdbTblBody, mdbTooltip, mdbBtn, mdbIcon, mdbSpinner, mdbDatePicker, mdbInput} from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import moment from 'moment';
import OrderDetailComponent from '../components/OrderDetailComponent';
import ConfirmationModal from '../components/ConfirmationModal';
import {checkPermissionsBinary} from '../js/helper';

export default {
  name: 'refund_orders',
  components: {
    mdbContainer, mdbRow, mdbCol, mdbTbl, mdbTblHead, mdbTblBody, mdbTooltip, mdbBtn, mdbIcon,
    AppNavigation, OrderDetailComponent, mdbSpinner, mdbDatePicker, ConfirmationModal, mdbInput
  },
  data: ()=>({
      loading: false,
      refund: [],
      from: "",
      to: "",
      order_number:"",
      promo_codes: [],
      focus_order_id: 0,
      order_detail_component: false,
      confirmation_refund: false,
      confirmation_voucher: false,
      focus_order: null,
      status: ""
  }),
  methods: {
    getData(){
        if(!checkPermissionsBinary(56, this.$store.state.permissions)){
            this.accessDenied();
            return;
        }
        if(this.loading){
            return false;
        }
        this.loading=true;
        ajax({
            url: "admin/refund_orders",
            data: {
                order_number:this.order_number,
                from: this.from,
                to: this.to,
                status: this.status
            },
            complete: ()=>this.loading=false,
            success: result=>{
                result.data.forEach(refund => {
                    refund.is_loading=false;
                });
                this.refund=result.data;
            },
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    momentFormat16(date){
        if(date){
            return moment(date, "YYYY-MM-DD h:mm:ss").utcOffset('+16:00').format('DD/MM/YYYY h:mm a');
        }
        return "";
    },
    momentFormat(date){
        if(date){
            return moment(date, "YYYY-MM-DD h:mm:ss").format('DD/MM/YYYY h:mm a');
        }
        return "";
    },
    showOrderDetail(id){
        this.focus_order_id=id;
        this.order_detail_component=true;
    },
    showCompensateVoucher(order){
        this.confirmation_voucher=true;
        this.confirmation_refund=false;
        this.focus_order=order;
    },
    closeOrderDetailComponent(){
        this.order_detail_component=false;
        this.confirmation_refund=false;
        this.confirmation_voucher=false;
        this.focus_order_id=0;
    },
    callback(){
        this.getData();
    },
    submitRefund(){
        if(!checkPermissionsBinary(57, this.$store.state.permissions)){
            this.accessDenied();
            return;
        }
        this.focus_order.is_loading=true;
        ajax({
            url: "admin/submit_refund",
            data: {
                ...this.focus_order
            },
            complete: ()=>this.focus_order.is_loading=false,
            success: ()=>{
                this.focus_order.is_refunded=1;
                this.closeOrderDetailComponent();
                this.$notify.success({message: "Refund Request Submitted", position: 'top right', timeOut: 5000})
            },
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    showSubmitRefund(order){
        this.confirmation_voucher=false;
        this.confirmation_refund=true;
        this.focus_order=order;
    },
    rejectRefund(order){
        if(!checkPermissionsBinary(59, this.$store.state.permissions)){
            this.accessDenied();
            return;
        }
        order.is_loading=true;
         ajax({
            url: "admin/delete_refund",
            data: {
                id: order.id
            },
            complete: ()=>order.is_loading=false,
            success: ()=>{
                order.is_deleted=1;
                this.$notify.success({message: 'Refund Declined', position: 'top right', timeOut: 5000})
            },
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    checkDisabled(order){
        if(order.is_refunded==1 || order.is_deleted==1){
            return true;
        }
        return false;
    },
    accessDenied(){
        this.$notify.error({message: "Access Denied.", position: 'top right', timeOut: 5000})
    },
    compensateVoucher(){
        if(!checkPermissionsBinary(58, this.$store.state.permissions)){
            this.accessDenied();
            return;
        }
        this.focus_order.is_loading=true;
        ajax({
            url: "admin/submit_refund_compensate_voucher",
            data: {
                id: this.focus_order.id
            },
            complete: ()=>this.focus_order.is_loading=false,
            success: ()=>{
                this.focus_order.is_refunded=1;
                this.closeOrderDetailComponent();
                this.$notify.success({message: "Refund Success", position: 'top right', timeOut: 5000})
            },
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    navigateToUser(phone){
        if(checkPermissionsBinary(3, this.$store.state.permissions)){
            this.$router.push({ name: 'users', params: {phone: phone}});
        }
    },
    permissionCheck(permission){
        return checkPermissionsBinary(permission, this.$store.state.permissions);
    },
  },
  mounted: function(){
    if(checkPermissionsBinary(56, this.$store.state.permissions)){
        let date = new Date();
        let month = date.getMonth()+1;
        let today=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
        let tomorrow=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
        this.from=today;
        this.to=tomorrow;
        this.getData();
        scroll(()=>this.getData());
        ajax({
            url: "admin/get_compensate_voucher",
            success: result=>{
                this.promo_codes=result.data;
            }
        })
    }
        
  }
}
</script>

<style scoped>
.status-cancelled{
    border: 1.5px solid #ff4444;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff4444;
    background-color: #fff;
}
.status-completed{
    border: 1.5px solid #00C851;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00C851;
    background-color: #fff;
}
.status-new{
    border: 1.5px solid #4285F4;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4285F4;
    background-color: #fff;
}
.order-number-text:hover{
    color: #4285F4;
    font-weight: bold;
    cursor: pointer;
}
</style>